import { useEffect, useRef, useState } from "react";
import { Spinner } from "../components/common/Spinner"
import { SpinnerContainer } from "../components/common/SpinnerContainer"
import { TabButton } from "../components/profile/TabButton"
import TabContent from "../components/profile/TabContent";
import logo from '../assets/images/Rentic_logo.svg';
import { Input } from "../components/form/Input";
import { Label } from "../components/form/Label";
import Switch from "@mui/material/Switch";
import { UserRentalsList } from "./UserRentalsList";
import { deleteProfile, getProfileEditData, updateProfile } from "../api/requests/profile";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { PrimaryButton } from "../components/buttons/PrimaryButton";
import ReactDOM from "react-dom";
import { DeleteButton } from "../components/buttons/DeleteButton";
import { AxiosRequestConfig } from "axios";
import api from "../api/apiInstance";
import { addNotification, NotificationType } from "../store/features/notificationsSlice";
import { useAppDispatch } from "../store/hooks";
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { ReactComponent as SmartIDLoginButton } from '../components/form/Smart-ID_login_btn.svg';
import { addEmail, attachSmartIdRequest } from "../api/requests/auth";
import { AddEmailResponseStatus, SmartIdAttachStatus } from "../api/requests/interfaces/Auth";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export const ProfilePage: React.FC = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchProfileData();
    }, [])

    const fetchProfileData = async () => {
        setLoading(true);
        const data = await getProfileEditData();
        if (data.email) {
            setEmail(data.email);
            setInitialEmail(data.email);
        } else {
            setEmail("");
            setInitialEmail("");
        }
        setName(data.name);
        setAddress(data.address);
        setProfilePicUrl(data.profilePicUrl);
        setVerifiedPerson(data.userIdentityVerified);
        setLoading(false);
    }

    const profileImageModal = useRef<HTMLDivElement>(null);
    const imageUploadRef = useRef<HTMLInputElement>(null);

    const [tabSelection, setTabSelection] = useState("personal_data");
    const [loading, setLoading] = useState(false);
    const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);
    const [smartIdOpen, setSmartIdOpen] = useState(false);

    const [profileImageModalOpen, setProfileImageModalOpen] = useState(false);

    const [email, setEmail] = useState("kristjan@spetsymarketing.com");
    const [initialEmail, setInitialEmail] = useState("");
    const [profilePicUrl, setProfilePicUrl] = useState("");
    const [username, setUsername] = useState("krissu3212");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("56666666");
    const [address, setAddress] = useState("Raatuse 12, Tartu, Tartu Maakond");
    const [verifiedPerson, setVerifiedPerson] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [identityVerificationError, setIdentityVerificationError] = useState(false);
    const [addEmailError, setAddEmailError] = useState(false);
    const [personalCode, setPersonalCode] = useState("");

    const [switch1Checked, setSwitch1Checked] = useState(true);
    const [switch2Checked, setSwitch2Checked] = useState(true);
    const [switch3Checked, setSwitch3Checked] = useState(Boolean);
    const [switch4Checked, setSwitch4Checked] = useState(true);

    useEffect(() => {
        if (profileImageModalOpen && profileImageModal.current) {
            console.log('here1111');
            document.body.append(profileImageModal.current);
        }
        return () => {
            // Clean up: remove the element from the body when closed
            if (profileImageModal.current) {
                document.body.removeChild(profileImageModal.current);
            }
        };
    }, [profileImageModalOpen])

    const handleProfileImageUpload = async (files: FileList | null) => {
        if (files === null || files?.item(0) === null) {
            return;
        }
        setProfileImageModalOpen(false);
        setIsUpdatingProfile(true);
        try {
            const config: AxiosRequestConfig = {
                onUploadProgress: progressEvent => {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
                    console.log("FILE PROGRESS, ", percentCompleted)
                },
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            var data = new FormData();
            data.append('file', files[0]);
            const res = await api.put<string>(process.env.REACT_APP_RENTIC_API_URL! + "/files/picture/update_profile_pic", data, config);
            setProfilePicUrl(res.data);
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Profiilipilt edukalt uuendatud", type: NotificationType.SUCCESS }));
        } catch {
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Profiilipildi uuendamisel esines viga", type: NotificationType.ERROR }));
        }
    }

    const handleUploadImageClick = () => {
        imageUploadRef.current?.click()
    }

    const handleDeleteImageClick = async () => {
        setProfileImageModalOpen(false);
        setIsUpdatingProfile(true);
        try {
            const res = await deleteProfile();
            setProfilePicUrl(res);
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Profiilipilt edukalt kustutatud", type: NotificationType.SUCCESS }));
        } catch {
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Profiilipildi kustutatimesl esines viga", type: NotificationType.ERROR }));
        }
    }

    function isValidEmail(emailAdr: string): boolean {
        const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(emailAdr);
    }

    function isValidPassword(password: string): boolean {
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
        return passwordRegex.test(password);
    }

    const handleUpdateProfileData = async () => {
        if (!name.length) {
            return;
        }
        setIsUpdatingProfile(true);
        try {
            const res = await updateProfile({ name: name, address: address });
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Profiil edukalt uuendatud", type: NotificationType.SUCCESS }));
        } catch {
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Profiili uuendamine ebaõnnestus", type: NotificationType.ERROR }));
        }
    }

    const handleChangeEmail = (emailAdr: string) => {
        setEmail(emailAdr);
        setAddEmailError(false);
        setValidEmail(isValidEmail(emailAdr));
    }

    const verifyUserIdentity = async () => {
        setIsUpdatingProfile(true);
        try {
            setIdentityVerificationError(false);
            // add maybe personal code validation here
            const res = await attachSmartIdRequest(personalCode);
            if (res.status === SmartIdAttachStatus.EXISTS) {
                setIdentityVerificationError(true);
                setIsUpdatingProfile(false);
                return;
            }
            setIsUpdatingProfile(false);
            navigate('/verify-smart-id?code=' + res.verificationCode);
            setIsUpdatingProfile(false);
        } catch {
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "Smart-ID liidestus ebaõnnestus", type: NotificationType.ERROR }));
        }
    }

    const handleVerifyEmail = async () => {
        setIsUpdatingProfile(true);
        try {
            setAddEmailError(false);
            if (validEmail && email.length) {
                const res = await addEmail({ email: email });
                if (res.status === AddEmailResponseStatus.USED) {
                    setAddEmailError(true);
                    setIsUpdatingProfile(false);
                    return;
                }
                setIsUpdatingProfile(false);
                navigate('/email-verify?verificationToken=' + res.emailVerificationToken);
            }
            setIsUpdatingProfile(false);
        } catch {
            setIsUpdatingProfile(false);
            dispatch(addNotification({ message: "E-posti aadressi kinnitamine ebaõnnestus", type: NotificationType.ERROR }));
        }
    }

    return (
        <div className="w-full h-full flex pt-[30px]">

            <Helmet>
                <title>Rentic - Profiil</title>
                <meta name="description" content="Vaata oma rendi ajalugu ning muuda profiili andmeid." />
                <meta name="keywords" content="profiil, profiili muutmine, rendifirma, Rentic" />
                <meta property="og:title" content="Rentic - Profiil" />
                <meta property="og:description" content="Vaata oma rendi ajalugu ning muuda profiili andmeid." />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/profile" />
            </Helmet>

            <div className="flex flex-col lg:flex-row gap-3 lg:gap-10 flex-grow justify-start text-left">
                {/* <div className="flex flex-wrap gap-y-1 gap-3 lg:gap-1 w-full items-start lg:items-stretch flex-shrink-0 lg:flex-col lg:p-10 lg:w-[320px]">
                    <TabButton
                        isSelected={tabSelection === "personal_data"}
                        onClick={() => setTabSelection("personal_data")}
                        label="Isiklikud andmed"
                    />
                    <TabButton
                        isSelected={tabSelection === "listings"}
                        onClick={() => setTabSelection("listings")}
                        label="Minu väljapanekud"
                    />
                    <TabButton
                        isSelected={tabSelection === "rentals"}
                        onClick={() => setTabSelection("rentals")}
                        label="Minu laenutatud"
                    />
                    <TabButton
                        isSelected={tabSelection === "following"}
                        onClick={() => setTabSelection("following")}
                        label="Jälgitavad"
                    />
                    <TabButton
                        isSelected={tabSelection === "conversations"}
                        onClick={() => setTabSelection("conversations")}
                        label="Vestlused"
                    />
                    <TabButton
                        isSelected={tabSelection === "help"}
                        onClick={() => setTabSelection("help")}
                        label="Abi"
                    />
                    <TabButton
                        isSelected={tabSelection === "logout"}
                        onClick={() => setTabSelection("logout")}
                        label="Logi välja"
                    />
                </div> */}
                <div className="w-full h-full">
                    <SpinnerContainer show={isUpdatingProfile} fullWidth={true}>
                        <TabContent isSelected={tabSelection === "personal_data"} >
                            <div className="flex flex-col w-full">
                                <div className="bg-primary h-[160px] w-full pl-5 pt-8 lg:pl-14 lg:pt-16">
                                    <div className={`flex rounded-[50%] relative bg-white shadow-main h-[160px] w-[160px] overflow-hidden justify-center translate-y-[0px] ${loading ? "skeleton_shine" : ""} cursor-pointer`} onClick={() => setProfileImageModalOpen(true)}>
                                        {
                                            !loading &&
                                            <img className="object-cover" src={profilePicUrl} alt="Profile picture" />
                                        }
                                        <div className="absolute bottom-0 h-[40px] bg-white bg-opacity-70 w-full flex justify-center">
                                            <CameraAltOutlinedIcon className="text-gray-500 mt-1" style={{ width: "30px", height: "30px" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="ml-[200px] pt-2 lg:ml-[250px] text-2xl font-bold">
                                    {name} {verifiedPerson &&
                                        <VerifiedUserOutlinedIcon style={{ width: "20px", height: "20px" }} className="text-primary font-bold" />
                                    }
                                </div>
                                {
                                    loading ?
                                        <div className="w-full h-full flex justify-center mt-10">
                                            <Spinner />
                                        </div>
                                        :
                                        <div className="flex flex-col lg:flex-row gap-10 p-5 lg:p-16 mt-10">
                                            <div className="flex flex-col gap-5">
                                                <h3>
                                                    Kontaktinfo
                                                </h3>
                                                <div>
                                                    <div className="pl-1">
                                                        <Label value={"Nimi"} />
                                                    </div>
                                                    {verifiedPerson ?
                                                        <div>{name}</div>
                                                        :
                                                        <Input value={name} onChange={(e) => setName(e)} placeHolder="Nimi" name="name"></Input>
                                                    }

                                                </div>
                                                <div>
                                                    <div className="pl-1">
                                                        <Label value={"E-posti aadress"} />
                                                    </div>
                                                    {/* <div className="pl-2">{email}</div> */}
                                                    <Input value={email} onChange={(e) => handleChangeEmail(e)} placeHolder="E-posti aadress" name="email"></Input>
                                                    {
                                                        (initialEmail != email && email.length && validEmail && !addEmailError) ?
                                                            <div className="text-primary underline hover:text-primary_darker pt-1 cursor-pointer" onClick={() => handleVerifyEmail()}>Kinnita e-post</div>
                                                            :
                                                            <></>
                                                    }
                                                    {(!validEmail && initialEmail != email) ?
                                                        <div className="text-red-500 text-sm pl-1">E-posti aadress pole korrektne</div>
                                                        :
                                                        <></>
                                                    }
                                                    {
                                                        addEmailError ?
                                                            <div className="pl-1 text-red-500 text-sm">E-posti aadress on juba kasutuses</div> :
                                                            <></>
                                                    }
                                                </div>
                                                {/* <div>
                                            <div className="pl-1">
                                                <Label value={"Telefon"} />
                                            </div>
                                            <Input value={phone} onChange={(e) => setPhone(e)} placeHolder="Telefoni number" name="phone"></Input>
                                            <div className="flex flex-row gap-4 align-middle items-center pt-1 pl-2">
                                                <Label value={"Näita kuulutustel minu telefoni numbrit"} />
                                                <Switch
                                                    checked={switch1Checked}
                                                    onChange={() => setSwitch1Checked(!switch1Checked)}
                                                />
                                            </div>
                                        </div> */}
                                                <div>
                                                    <div className="pl-1">
                                                        <Label value={"Aadress"} />
                                                    </div>
                                                    <Input value={address} onChange={(e) => setAddress(e)} placeHolder="Aadress" name="address"></Input>
                                                </div>
                                            </div>
                                            <div className="flex flex-col gap-5">
                                                <h3>
                                                    Kasutaja
                                                </h3>
                                                {/* <div>
                                            <div className="pl-1">
                                                <Label value={"Kasutajanimi"} />

                                            </div>
                                            <Input value={username} onChange={(e) => setUsername(e)} placeHolder="Kasutajanimi" name="username"></Input>

                                        </div> */}
                                                <div className="flex flex-col">
                                                    <div className="flex flex-row gap-4 align-middle items-center pt-1 pl-1">
                                                        <Label value={"Soovin saada personaalseid uudiseid emailile"} />
                                                        <Switch
                                                            checked={switch2Checked}
                                                            onChange={() => setSwitch2Checked(!switch2Checked)}
                                                        />
                                                    </div>
                                                    {/* <div className="flex flex-row gap-4 align-middle items-center pt-1 pl-1">
                                                        <Label value={"Peida kõik minu esemed"} />
                                                        <Switch
                                                            checked={switch3Checked}
                                                            onChange={() => setSwitch3Checked(!switch3Checked)}
                                                        />
                                                    </div> */}
                                                    {/* <div className="flex flex-row gap-4 align-middle items-center pt-1 pl-1">
                                                <Label value={"Näita kuulutustel minu telefoni numbrit"} />
                                                <Switch
                                                    checked={switch4Checked}
                                                    onChange={() => setSwitch4Checked(!switch4Checked)}
                                                />
                                            </div> */}
                                                </div>
                                                <div className="flex flex-col gap-5 mt-4">
                                                    <h3>
                                                        Verifitseerimine
                                                    </h3>
                                                    <div>
                                                        <div className="pl-1 text-sm max-w-[300px]">
                                                            Isiku kinnitanud kontode kõrval kuvame platformil verifitseeritud staatust märgiga <VerifiedUserOutlinedIcon style={{ width: "20px", height: "20px" }} className="text-primary font-bold" />.
                                                            See kinnitab müüjates ja ostjates konto autentsuse.
                                                        </div>
                                                    </div>
                                                    <div className={` ${smartIdOpen ? "w-[230px]" : "w-[180px]"} fit-content`}>
                                                        {
                                                            smartIdOpen ?
                                                                <div>
                                                                    <div className="flex flex-row w-full gap-1">
                                                                        <div className="flex-1">
                                                                            <Input value={personalCode} onChange={(e) => setPersonalCode(e)} placeHolder="Isikukood" name="personalCode"></Input>
                                                                        </div>
                                                                        <div className="flex-none">
                                                                            <PrimaryButton title='Edasi' onClick={() => verifyUserIdentity()} />
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        identityVerificationError &&
                                                                        <div className="text-red-500 text-sm pt-1 pl-1">Antud isik on juba verifitseeritud platvormil</div>
                                                                    }
                                                                </div>
                                                                :
                                                                <div className="w-full">
                                                                    <div className="relative">
                                                                        <SmartIDLoginButton style={{ width: '100%', height: 'fit-content' }} onClick={() => setSmartIdOpen(true)} className="cursor-pointer" />
                                                                        {verifiedPerson &&
                                                                            <div className="absolute w-full h-full bg-slate-400/70 blur-sm top-0 rounded-md"></div>
                                                                        }
                                                                    </div>
                                                                    {verifiedPerson &&
                                                                        <div className="text-gray-600 text-sm pt-1 pl-1">Konto on juba verifitseeritud</div>
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                }
                                {
                                    !loading &&
                                    <div className="w-full lg:w-[300px] lg:pl-16 pb-5 px-2">
                                        <PrimaryButton title={"Salvesta"} onClick={() => handleUpdateProfileData()} />
                                    </div>
                                }
                            </div>
                            {
                                profileImageModalOpen ?
                                    ReactDOM.createPortal(
                                        <div ref={profileImageModal} className="fixed w-full flex h-full bg-red top-0 left-0 items-center justify-center align-middle z-[200] bg-slate-500/50"
                                            onClick={() => setProfileImageModalOpen(false)}>
                                            <div onClick={(e) => e.stopPropagation()} className="bg-white flex flex-col rounded-lg p-6">
                                                <img src={profilePicUrl} className="w-[300px] h-[300px] rounded-full object-cover" />
                                                <div className="text-sm pt-3 flex flex-row"><p className="text-red-500 pr-1">*</p>Kuni 20MB (png, jpeg, jpg, heif, webp)</div>
                                                <div className="flex gap-1 pt-1">
                                                    <PrimaryButton title="Muuda" onClick={() => handleUploadImageClick()} />
                                                    <DeleteButton onClick={() => handleDeleteImageClick()} title="Kustuta" outlined={true} />
                                                </div>
                                                <input type="file" id="upload_pic" name="filename" className='hidden'
                                                    accept="image/png,image/jpeg,image/jpg,image/heif,image/webp" ref={imageUploadRef} onChange={(e) => { handleProfileImageUpload(e.target.files); e.target.files = null; }} />
                                            </div>
                                        </div>,
                                        document.body)
                                    :
                                    <></>
                            }

                        </TabContent>

                    </SpinnerContainer>

                    <TabContent isSelected={tabSelection === "orders"}>
                        <div className="flex flex-col lg:gap-10 w-full lg:p-16">
                            <h3>Minu välja renditud esemed</h3>
                            <UserRentalsList />
                        </div>

                    </TabContent>
                    <TabContent isSelected={tabSelection === "following"}>
                        Following tab
                    </TabContent>

                </div>

            </div>
        </div>
    )
}